import alt from "../alt";

class PersonaDashboardActions {
  setToggle(name, value) {
    return { name, value };
  }
}

export default alt.createActions(PersonaDashboardActions);
